import React, { useEffect, useState, useRef } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from "./components/Header/Header";
import IndexAboutUs from "./components/aboutUs/IndexAboutUs";
import IndexBlogs from "./components/blogs/IndexBlogs";
import Footer from "./components/common/Footer";
import IndexContactUs from "./components/contactUs/IndexContectUs";
import IndexFirst from "./components/firstScreen/IndexFirst";
import IndexPrivacyPolicy from "./components/privacyPolicy/IndexPrivacyPolicy";
import IndexTermOfUse from "./components/termsOfUse/IndexTermOfUse";
import IndexOurServices from "./components/ourServices/IndexOurServices";
import IndexSolutions from "./components/solutions/IndexSolutions";
import CookiesPolicy from "./components/firstScreen/CookiesPolicy";
import { useTranslation } from "react-i18next";
import Error404 from "./components/common/Error404";

import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAte5Mv0xTXZDofm_KLx3CQyVK0biwo25E",
  authDomain: "vitta-technology-5076f.firebaseapp.com",
  projectId: "vitta-technology-5076f",
  storageBucket: "vitta-technology-5076f.appspot.com",
  messagingSenderId: "63721318128",
  appId: "1:63721318128:web:3966def405976f63a00435",
  measurementId: "G-JZNHPYH4Z6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function App() {
  const headerRef = useRef(null);
  const sectionRef = useRef(null);
  const { t } = useTranslation();
  const [headerHeight, setHeaderHeight] = useState(0);
  const location = useLocation();
  let navigate = useNavigate();
  const [isShowAcceptCookies, setIsShowCookies] = useState("yes");
  const [isCookiesAccept, setIsCookiesAccept] = useState(false);

  const routes = [
    { name: "Home", path: "/", element: <IndexFirst /> },
    {
      name: "Our Services",
      path: "/our-services",
      element: <IndexOurServices />,
    },
    { name: "Contact Us", path: "/contact-us", element: <IndexContactUs /> },
    { name: "Team", path: "/team", element: <IndexAboutUs /> },
    { name: "Resources", path: "/resources", element: <IndexBlogs /> },
    {
      name: "Solutions",
      path: "/solutions",
      element: <IndexSolutions sectionRef={sectionRef} />,
    },
    {
      name: "Cookies Policy",
      path: "/cookiesPolicy",
      element: <CookiesPolicy />,
    },
    {
      name: "Privacy Policy",
      path: "/privacy-policy",
      element: <IndexPrivacyPolicy />,
    },
    {
      name: "Terms of Use",
      path: "/terms-of-use",
      element: <IndexTermOfUse />,
    },
  ];

  useEffect(() => {
    if (headerRef.current) {
      const height = headerRef.current.clientHeight;
      setHeaderHeight(height);
    }
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        const offsetTop = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: offsetTop - headerHeight,
          left: 0,
          behavior: "smooth",
        });
        return;
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, [location.pathname, headerHeight]);

  useEffect(() => {
    const cookiesAccept = localStorage.getItem("is_cookies");
    setIsShowCookies(cookiesAccept === null ? "no" : "yes");
  }, [isCookiesAccept]);

  useEffect(() => {
    let currentPageName = routes.find(
      (item) => item.path === window.location.pathname
    );

    const startTime = Date.now();
    logEvent(analytics, "page_view", {
      page_title: currentPageName?.name,
      start_time: startTime,
    });
    return () => {
      const endTime = Date.now();
      const timeSpent = endTime - startTime;

      // Log the time spent on the page
      logEvent(analytics, "time_spent_on_page", {
        page_title: currentPageName?.name,
        time_spent: timeSpent,
      });
    };
  }, [window.location.pathname]);

  return (
    <>
      <ToastContainer
        style={{ fontSize: "14px" }}
        autoClose={2000}
        hideProgressBar={true}
      />
      <Header headerRef={headerRef} headerHeight={headerHeight} />
      <Routes>
        {routes.map((item, index) => {
          return <Route key={index} path={item.path} element={item.element} />;
        })}
        {/* <Route path="/" element={<IndexFirst />} />
        <Route path="/our-services" element={<IndexOurServices />} />
        <Route path="/contact-us" element={<IndexContactUs />} />
        <Route path="/team" element={<IndexAboutUs />} />
        <Route path="/resources" element={<IndexBlogs />} />
        <Route path="/solutions" element={<IndexSolutions sectionRef={sectionRef} />} />
        <Route path="/cookiesPolicy" element={<CookiesPolicy />} />
        <Route path="/privacy-policy" element={<IndexPrivacyPolicy />} />
        <Route path="/terms-of-use" element={<IndexTermOfUse />} /> */}
        <Route path="*" element={<Error404 />} />
      </Routes>
      {isShowAcceptCookies === "no" && (
        <div
          className={` border border-[#C0CDF8] bg-gradient-to-r from-blue-200 via-white to-blue-200 py-4 sm:flex justify-center items-center px-3 fixed bottom-0 w-[100%] z-[999]`}
        >
          <div className="text-[#141619] text-[12px] sm:text-[14px] text-center font-normal w-full">
            <span>{t("cookie_content")}</span>
            <span
              className="underline cursor-pointer font-bold"
              onClick={() => navigate("/cookiesPolicy")}
            >
              {t("cookie_policy")}.
            </span>
          </div>
          <div className="flex justify-center pt-1 sm:pt-0">
            <button
              onClick={() => {
                localStorage.setItem("is_cookies", "yes");
                setIsCookiesAccept(true);
              }}
              className={`flex bg-[#3359D3] ms-4 h-[fit-content] px-4 py-1 text-[12px] sm:text-[16px] rounded-[8px] font-normal items-center text-white hover:bg-opacity-80`}
            >
              {t("accept")}
            </button>
          </div>
        </div>
      )}
      <Footer headerHeight={headerHeight} sectionRef={sectionRef} />
      {/* <Routes>
        <Route path="*" element={<Error404 />} />
      </Routes> */}
    </>
  );
}

export default App;
